import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import css from './styles.module.scss';
import { Avatar, Box, Card, CardHeader, Grid, IconButton, Typography } from '@material-ui/core';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { getUserData } from '~/store/user/selectors';
import { ProfileContent } from '../../components/profile-content';
import { ProfileGeneral } from '../../components/profile-general';
import { ProfileLocalization } from '../../components/profile-localization';
import { ProfileDefaults } from '../../components/profile-defaults';
import { ProfileListings } from '../../components/profile-listings';
import { UserProfile } from '~/models/profile/UserProfile.dto';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { goBack } from 'connected-react-router';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';

interface Props {
}

export const ProfilePage: React.FC<Props> = () => {

    const dispatch = useThunkDispatch();
    const { data: user } = useSelector(getUserData);
    const [valueTab, setValueTab] = useState(0);
    const [userProfile, setUserProfile] = useState(new UserProfile());

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValueTab(newValue);
    };

    function a11yProps(index: any) {
        return {
            id: `tab-${index}`,
            'aria-controls': `tabpanel-${index}`,
        };
    }

    const changeData = (data: any) => {
        if (data) {
            if (!data.firstName) {
                data.firstName = user?.name;
            }
            if (!data.lastName) {
                data.lastName = user?.lastName;
            }
            if (!data.email) {
                data.email = user?.email;
            }
            if (!data.image) {
                data.image = '';
            }

            setUserProfile({ ...userProfile, ...data });
        }
    };

    const getContent = () => {
        const tabs: any = {
            0: ProfileGeneral,
            1: ProfileLocalization,
            2: ProfileDefaults,
            3: ProfileListings,
        };

        const Content = tabs[valueTab];
        return <Content user={user} tab={valueTab} changeData={changeData}/>;
    };

    const backPage = () => {
        dispatch(goBack());
    };

    return (

        <Box className={css.module}>
            <article className={css.contentWrapper}>

                <Grid container spacing={0}>

                    <Grid item xs={12} className={css.header}>
                        <Box display="flex" alignItems="center">
                            <Box display="flex" justifyContent="left" flexGrow="1">
                                <Box className={css.closeDrawer}>
                                    <IconButton onClick={backPage}>
                                        <ArrowBackIcon/>
                                    </IconButton>
                                    <Typography>Back</Typography>
                                </Box>
                            </Box>

                            <Box justifyContent="left" flexGrow="1">
                                <Box className={css.closeBox}>
                                    <Card elevation={0} className={css.contactCardProfile}>
                                        <CardHeader
                                            className={css.contactCardHeaderProfile}
                                            avatar={
                                                <AvatarGroup>
                                                    <Avatar
                                                        variant="square"
                                                        className={css.avatarProfile}
                                                        alt={userProfile?.firstName}
                                                        src={userProfile?.image}
                                                    />
                                                </AvatarGroup>
                                            }
                                            title={`${userProfile?.firstName} ${userProfile?.lastName}`.trim()}
                                            subheader={userProfile?.email}
                                        />
                                    </Card>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <div className={css.topBarActions}>
                            <AppBar className={css.appTop} position="static">
                                <Tabs value={valueTab} className={css.topBar} onChange={handleChange} aria-label="simple tabs example">
                                    <Tab label="General" {...a11yProps(0)} />
                                    <Tab label="Localization" {...a11yProps(1)} />
                                    <Tab label="Defaults" {...a11yProps(2)} />
                                    <Tab label="Listings" {...a11yProps(3)} />
                                </Tabs>
                            </AppBar>
                        </div>
                    </Grid>

                    <Grid item xs={12} className={css.content}>
                        <ProfileContent content={getContent}/>
                    </Grid>
                </Grid>

            </article>
        </Box>
    );
};
